import React from 'react';
import { Navigate } from 'react-router-dom';

// Auth
import Login from '../pages/Auth/Login';
import Logout from '../pages/Auth/Logout';
import ResetPassw from '../pages/Auth/ResetPassw';
import Page404 from '../pages/Auth/Error404';
import OAuthCallback from '../pages/Auth/OAuthCallback';

// Páginas
import Dashboard from '../pages/Dashboard';
import User from '../pages/User';
import Advertiser from '../pages/Advertiser';
import Agency from '../pages/Agency';
import AdNetwork from '../pages/AdNetwork';
import Order from '../pages/Order';
import Campaign from '../pages/Campaign';
import Publisher from '../pages/Publisher';
import Placement from '../pages/Placement';
import Tag from '../pages/Tag';
import ForgetPasswordPage from '../pages/Auth/ForgetPassword';
import AuditLog from '../pages/AuditLog';
import ExitImpersonation from '../pages/ExitImpersonation';
import Report from '../pages/Report';
import BlockedKeywords from '../pages/BlockedKeywords';
import Creative from '../pages/Creative';
import APIKey from '../pages/APIKey';
import Support from '../pages/Support';
import { useProfile } from '../hooks/UserHooks';
import AddEditTag from '../pages/Tag/EditTag';
import Integration from '../pages/Integration';
import Site from '../pages/Site';

const Routes = () => {
    const { userProfile } = useProfile();

    const authProtectedRoutes = [
        {
            path: '/',
            component: <Dashboard/>
        },
        // Companies
        {
            path: '/advertiser',
            component: userProfile?.role === 'ROLE_SUPER_ADMIN' ? <Advertiser/> : <Navigate to="/"/>
        },
        {
            path: '/agency',
            component: userProfile?.role === 'ROLE_SUPER_ADMIN' ? <Agency/> : <Navigate to="/"/>
        },
        {
            path: '/ad-network',
            component: userProfile?.role === 'ROLE_SUPER_ADMIN' ? <AdNetwork/> : <Navigate to="/"/>
        },
        {
            path: '/publisher',
            component: <Publisher/>
        },
        // Delivery
        {
            path: '/campaign',
            component: <Campaign/>
        },
        {
            path: '/order',
            component: <Order/>
        },
        {
            path: '/creative',
            component: <Creative/>
        },
        // Inventory
        {
            path: '/site',
            component: <Site/>
        },
        {
            path: '/placement',
            component: <Placement/>
        },
        {
            path: '/tag',
            component: <Tag/>
        },
        {
            path: '/tag/new',
            component: <AddEditTag/>
        },
        {
            path: '/tag/:id',
            component: <AddEditTag/>
        },
        // Protections
        {
            path: '/blocked-keywords',
            component: <BlockedKeywords/>
        },
        // Admin
        {
            path: '/user',
            component: <User/>
        },
        {
            path: '/audit-log',
            component: <AuditLog/>
        },
        {
            path: '/api-keys',
            component: <APIKey/>
        },
        {
            path: '/support',
            component: <Support/>
        },
        // Integrations
        {
            path: '/integrations',
            component: <Integration/>
        },
        // Other routes
        {
            path: '/campaign/report/:campaignId',
            component: <Report/>
        },
        {
            path: '/exit-impersonation',
            component: <ExitImpersonation/>
        },
        // this route should be at the end of all other routes
        // eslint-disable-next-line react/display-name
        {
            path: '/',
            exact: true,
            component: <Navigate to="/campaign"/>,
        },
        { path: '*', component: <Page404/> },
    ];

    const publicRoutes = [
        // Authentication Page
        { path: '/logout', component: <Logout/> },
        { path: '/login', component: <Login/> },
        { path: '/forgot-password', component: <ForgetPasswordPage/> },
        { path: '/reset-password', component: <ResetPassw/> },
        { path: '/oauth/callback', component: <OAuthCallback/> },
    ];

    return { authProtectedRoutes, publicRoutes };
};

export default Routes;